import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchApiGateway } from "@nova/fetch-api-gateway"

export const fetchMe = createAsyncThunk("profile/fetchMe", async (_, thunkApi) => {
    let data
    try {
        data = await fetchApiGateway("get /me")
    } catch (error) {
        console.error("Fetch user profile error:", error)
        return thunkApi.rejectWithValue("Failed to fetch user profile")
    }

    if (!data.license || !data.liteLicense) {
        return thunkApi.rejectWithValue("Failed to normalize user licenses")
    }

    return data
})
